function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 402,
  width: 582,
  y: -1,
  x: -1
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("g", {
  id: "Vrstva_3"
}), React.createElement("g", {
  id: "Vrstva_2"
}, React.createElement("g", {
  id: "svg_1"
}, React.createElement("path", {
  id: "svg_2",
  d: "m146.572,464.052c0,-25.971 6.151,-41.234 30.527,-41.234c24.376,0 30.527,15.036 30.527,41.234c0,27.565 -6.037,40.551 -30.527,40.551c-24.603,0.001 -30.527,-14.124 -30.527,-40.551zm56.726,0c0,-23.579 -4.784,-37.361 -26.198,-37.361c-21.643,0 -26.199,13.555 -26.199,37.361c0,23.92 4.214,36.678 26.199,36.678c21.983,0 26.198,-11.618 26.198,-36.678z",
  fill: "#FFFFFF"
}), React.createElement("path", {
  id: "svg_3",
  d: "m224.028,503.578l0,-56.954l3.987,0l0,4.557c0,0 10.138,-5.582 19.934,-5.582c15.492,0 18.681,6.265 18.681,28.363l0,29.616l-3.986,0l0,-29.388c0,-19.364 -2.05,-24.945 -14.694,-24.945c-10.138,0 -19.934,5.695 -19.934,5.695l0,48.638l-3.988,0z",
  fill: "#FFFFFF"
})), React.createElement("g", {
  id: "svg_4"
}, React.createElement("path", {
  id: "svg_5",
  d: "m725.572,463.052c0,-25.971 6.15,-41.234 30.527,-41.234c24.376,0 30.527,15.036 30.527,41.234c0,27.565 -6.037,40.551 -30.527,40.551c-24.603,0.001 -30.527,-14.124 -30.527,-40.551zm56.726,0c0,-23.579 -4.784,-37.361 -26.198,-37.361c-21.643,0 -26.199,13.555 -26.199,37.361c0,23.92 4.215,36.678 26.199,36.678s26.198,-11.618 26.198,-36.678z",
  fill: "#FFFFFF"
}), React.createElement("path", {
  id: "svg_6",
  d: "m809.18,502.578l-3.986,0l0,-53.308l-7.86,0l0,-3.645l7.86,0l0,-6.948c0,-16.402 4.1,-20.275 14.465,-20.275c3.987,0 10.48,0.342 10.48,0.342l0,3.531c0,0 -7.291,-0.228 -10.48,-0.228c-7.745,0 -10.479,3.076 -10.479,16.744l0,6.834l18.453,0l0,3.645l-18.453,0l0,53.308z",
  fill: "#FFFFFF"
}), React.createElement("path", {
  id: "svg_7",
  d: "m844.831,502.578l-3.986,0l0,-53.308l-7.86,0l0,-3.645l7.86,0l0,-6.948c0,-16.402 4.101,-20.275 14.466,-20.275c3.986,0 10.479,0.342 10.479,0.342l0,3.531c0,0 -7.29,-0.228 -10.479,-0.228c-7.746,0 -10.479,3.076 -10.479,16.744l0,6.834l18.453,0l0,3.645l-18.453,0l0,53.308l-0.001,0z",
  fill: "#FFFFFF"
})), React.createElement("g", {
  id: "svg_8"
}, React.createElement("path", {
  id: "svg_9",
  d: "m375.648,267.843l8.657,0l28.021,73.47l28.021,-73.47l8.657,0l0,79.735l-4.101,0l0,-75.862l-1.595,0l-28.021,73.47l-5.923,0l-28.021,-73.47l-1.595,0l0,75.862l-4.101,0l0,-79.735l0.001,0z",
  fill: "#FFFFFF"
}), React.createElement("path", {
  id: "svg_10",
  d: "m507.781,343.933l0.227,3.645c0,0 -12.757,1.025 -21.072,1.025c-16.972,-0.114 -21.415,-10.935 -21.415,-29.502c0,-22.554 10.024,-29.502 23.009,-29.502c14.011,0 21.643,7.632 21.643,27.337l0,3.759l-40.437,0c0,15.719 4.101,24.262 17.313,24.262c7.974,0.001 20.732,-1.024 20.732,-1.024zm-1.823,-26.882c0,-17.428 -5.582,-23.807 -17.428,-23.807c-11.391,0 -18.794,6.493 -18.794,23.807l36.222,0z",
  fill: "#FFFFFF"
}), React.createElement("path", {
  id: "svg_11",
  d: "m525.096,347.578l0,-56.954l3.986,0l0,4.557c0,0 10.138,-5.582 19.934,-5.582c15.492,0 18.681,6.265 18.681,28.363l0,29.616l-3.986,0l0,-29.388c0,-19.364 -2.051,-24.945 -14.694,-24.945c-10.138,0 -19.934,5.695 -19.934,5.695l0,48.638l-3.987,0z",
  fill: "#FFFFFF"
}), React.createElement("path", {
  id: "svg_12",
  d: "m625.902,290.625l0,56.954l-3.986,0l0,-4.556c0,0 -8.885,5.582 -18.681,5.582c-15.491,0 -18.681,-6.265 -18.681,-28.363l0,-29.616l3.986,0l0,29.388c0,19.364 2.051,24.946 14.694,24.946c10.138,0 18.681,-5.696 18.681,-5.696l0,-48.638l3.987,0l0,-0.001z",
  fill: "#FFFFFF"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_13"
}, React.createElement("path", {
  stroke: "null",
  id: "svg_14",
  d: "m701.000009,497l0,156c0,9.112 -7.387,16.5 -16.500001,16.5s-16.500001,-7.388 -16.500001,-16.5l0,-156c0,-9.113 7.387,-16.5 16.500001,-16.5s16.500001,7.387 16.500001,16.5",
  fill: "#FFFFFF"
}), React.createElement("path", {
  stroke: "null",
  id: "svg_15",
  d: "m737.000011,609l-469.000019,0c-3.313,0 -6,-2.687 -6,-6s2.687,-6 6,-6l469.000019,0c3.313,0 6,2.687 6,6s-2.687,6 -6,6",
  fill: "#FFFFFF"
})), React.createElement("g", {
  opacity: 0,
  stroke: "null",
  id: "svg_18"
}, React.createElement("path", {
  stroke: "null",
  id: "svg_16",
  d: "m304,497l0,156c0,9.112 7.387,16.5 16.5,16.5s16.5,-7.388 16.5,-16.5l0,-156c0,-9.113 -7.387,-16.5 -16.5,-16.5s-16.5,7.387 -16.5,16.5",
  fill: "#FFFFFF"
}), React.createElement("path", {
  stroke: "null",
  id: "svg_17",
  d: "m268,609l469,0c3.313,0 6,-2.687 6,-6s-2.687,-6 -6,-6l-469,0c-3.313,0 -6,2.687 -6,6s2.687,6 6,6",
  fill: "#FFFFFF"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/custom-menu-off.c4c83275.svg";
export { SvgComponent as ReactComponent };